import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class GridService {
    public refreshData = new Subject<any>();

}